import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import classNames from "classnames";
import Stack from "@mui/material/Stack";
import editJsonFile from "edit-json-file";
import path from "path";
import {
  TextField,
  InputLabel,
  Input,
  Button,
  Autocomplete,
} from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
//import {  } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core";
//import CurrencyFormat from 'react-currency-format';

import {
  listRecordCategories,
  addcategoryrec,
} from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";

import Notification from "../components/Notification";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

const useStyles = makeStyles(styles);

export default function AddCategoryScreen(props) {
  // const __dirname = path.resolve(path.dirname("assets/data"));
  let writejsonfile = editJsonFile("foo.json");

  const classes = useStyles();
  const addCategory = useSelector((state) => state.addCategory);
  const recordCategoryList = useSelector((state) => state.recordCategoryList);
  const {
    loading: loadingCategories,
    error: errorCategories,
    summary: recordcategories,
  } = recordCategoryList;
  const { addCategoryRec, loading, error } = addCategory; //use previous records
  const [category, setCategory] = useState("addCategoryRec.category");
  const [otherinfo, setOtherinfo] = useState("addCategoryRec.otherinfo");

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  /*
  const redirect = props.location.search
    ? props.location.search.split('=')[1]
    : '/';
*/
  const navigate = useNavigate();
  // const { requrl }= useParams();
  /** The current relative URL (pathname + search + hash). */
  /*
 const requrl = ()=> {
   const loc = props.location;
   return loc.pathname + loc.search + loc.hash;
  };
 const redirect = requrl.search
 ? requrl.search.split('=')[1]
 : '/';
*/
  const redirect = "/addcategory";

  console.log("summary:" + recordcategories);
  console.log("__dirname:" + __dirname);

  const dispatch = useDispatch();
  const submitHandler = (e) => {
    /*
    writejsonfile.append({
      id: "22",
      category: category,
    });
    */
    e.preventDefault();
    //   if (password !== confirmPassword) {
    //     alert('Password and confirm password are not match');
    //   } else {
    dispatch(addcategoryrec(category, otherinfo));
    //   }
  };

  /*
  useEffect(() => {
    if (userInfo) {
      props.history.push(redirect);
    }
  }, [props.history, redirect, userInfo]);
*/

  const handleSelectChange = (e) => {
    setCategory(e.target.value);
    console.log("selected category:" + category);
  };

  useEffect(() => {
    dispatch(listRecordCategories());
    if (addCategoryRec) {
      setNotify({
        isOpen: true,
        message: "Category Submitted Successfully",
        type: "success",
      });
      navigate(redirect, { replace: true });
    } else {
      console.log("error" + error);
      setNotify({
        isOpen: true,
        message: error,
        type: "failure",
      });
    }
  }, [dispatch, props.history, redirect, addCategoryRec]);

  return (
    <div>
      <div className={classes.space30}> </div>
      <GridContainer justify="center" className={classes.contentText}>
        <GridItem xs={12} sm={12} md={4}>
          <Button
            variant="outlined"
            className="medium"
            startIcon={
              <KeyboardBackspaceOutlinedIcon sx={{ color: "#E91E63" }} />
            }
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          {loading && <LoadingBox></LoadingBox>}
          {error && <MessageBox variant="danger">{error}</MessageBox>}
          <form className="form" onSubmit={submitHandler}>
            <div>
              <h3>Input Category</h3>
            </div>

            <div className={classes.space30}> </div>
            {loadingCategories ? (
              <LoadingBox></LoadingBox>
            ) : errorCategories ? (
              <MessageBox variant="danger">{errorCategories}</MessageBox>
            ) : (
              <Autocomplete
                id="category"
                freeSolo
                options={recordcategories.categories.map((x) => x.category)}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Category "
                    defaultValue="Select one Category or input new Category "
                    helperText="Select one Category or input new Category "
                    variant="standard"
                    required
                  />
                )}
                // onChange={(e) => setDescription(value)}
                onChange={(event, newValue) => {
                  setCategory(newValue);
                }}
                onInputChange={(event, newInputValue) => {
                  setCategory(newInputValue);
                }}
              />
            )}
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="otherinfo">other information</InputLabel>
              <Input
                id="otherinfo"
                placeholder="please add more information if needs"
                required
                sx={{ width: 300 }}
                onChange={(e) => setOtherinfo(e.target.value)}
              ></Input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <label />
              <Button
                variant="contained"
                className={classes.btnColor}
                type="submit"
              >
                Add Category
              </Button>
            </div>
            {/*        
        <div>
          <label />
          <div>
            Already have an account?{' '}
            <Link to={`/signin?redirect=${redirect}`}>Sign-In</Link>
          </div>
        </div> 
    */}
          </form>
          <Notification notify={notify} setNotify={setNotify}></Notification>
        </GridItem>
      </GridContainer>
    </div>
  );
}
